/** Survives full-page OAuth redirects (sessionStorage). */
const KEY = 'easybail_pendingApplyListingId'

export function setPendingApplyListingId(id: string): void {
  try {
    sessionStorage.setItem(KEY, id)
  } catch {
    /* ignore quota / private mode */
  }
}

export function getPendingApplyListingId(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function clearPendingApplyListingId(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
